import Axios from 'axios'
import { Dispatch } from 'redux'
import { clearAlert, createAlert, handleError } from 'util/modules/Alert/redux/actions'
import { ActionResponse, Id } from 'util/types/index'
import { Address, AddressData, AddressTypes } from './types'

export function createAddress (personId: Id, data: Partial<AddressData>) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Address>> => {
    return Axios
      .post(`/person/${personId}/address`, data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: AddressTypes.ADDRESS_CREATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao cadastrar o endereço')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function updateAddress (personId: Id, id: Id, data: Partial<AddressData>) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Address>> => {
    return Axios
      .put(`/person/${personId}/address/${id}`, data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: AddressTypes.ADDRESS_UPDATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao atualizar o endereço')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function deleteAddress (personId: Id, id: Id) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Address>> => {
    return Axios
      .delete(`/person/${personId}/address/${id}`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: AddressTypes.ADDRESS_DELETE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao remover o endereço')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function getAddress (personId: Id, id: Id) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Address>> => {
    return Axios
      .get(`/person/${personId}/address/${id}`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: AddressTypes.ADDRESS_GET, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao buscar o endereço')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function getAddressList (personId: Id) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Address[]>> => {
    return Axios
      .get(`/person/${personId}/address`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: AddressTypes.ADDRESS_GET_LIST, payload: res.data })
        }
        return res
      })
  }
}
